import httpClient from './httpClient';

export const ATTRIBUTE_KEY_ENDPOINT = '/backoffice/attribute-keys';

export const getAttributeKeysAPI = async (params) => httpClient.get(`${ATTRIBUTE_KEY_ENDPOINT}`, { params });
export const createAttributeKeyAPI = async (name) => httpClient.post(`${ATTRIBUTE_KEY_ENDPOINT}`, { name });
export const deleteAttributeKeyAPI = async (attributeKeyId) => httpClient.delete(`${ATTRIBUTE_KEY_ENDPOINT}/${attributeKeyId}`);
